import { useEffect, useState, React, lazy, Suspense } from "react";
// import { SessionContext } from "./Lib/Context";
import MiddleWare from "./Pages/MiddleWare";
import useSessionStore from "./Lib/Context";
import queryString from 'query-string';
import Spinner from "./Components/Spinner";
import { getCurrentBrowserFingerPrint } from "@rajesh896/broprint.js";
import { sanitizeRedirectUrl } from "./utils/urlValidation";
import { Toaster } from 'react-hot-toast';

// Lazy load ErrorPage - only needed when errors occur
const Error = lazy(() => import("./Components/ErrorPage"));


// UrlParameters.hostname = `${window.location.protocol}//${window.location.hostname}`;

function App() {
    // const [SessionData, setSessionData] = useState();
    const [isLoading, setisLoading] = useState(true);
    const { SessionData, setSessionData } = useSessionStore();
    const [hasURLParams, sethasURLParams] = useState(false);
    const [ErrorState, setErrorState] = useState(false);
    const UrlParameters = queryString.parse(window.location.search)
    const UrlPathname = window.location.pathname
    const deconstructPathName = UrlPathname.split("/").filter(Boolean);
    const firstPath = deconstructPathName[0]
    const secondPath = deconstructPathName[1]
    const thirdPath = deconstructPathName[2]
    const fourthPath = deconstructPathName[3]



    
    useEffect(() => {
      if (firstPath==="fatti"){
        SessionData.firstPath = firstPath
        SessionData.secondPath = secondPath
        SessionData.thirdPath = thirdPath
        SessionData.fourthPath = fourthPath
        SessionData.savedRedirect = window.location.search + window.location.hash
        console.log(SessionData)
      }else{
        console.log("FirstPath is empty")
      }
      if (Object.keys(UrlParameters).length === 0){
        setErrorState("Prechecks Failed")
      } else {
        getCurrentBrowserFingerPrint().then((fingerprint) => {
          // UrlParameters.clientID = fingerprint.toString();
          SessionData.clientID = fingerprint.toString();
        }).then(() => {
          sethasURLParams(true)
        });
      }
    },[]);

    useEffect(() => {
      if(hasURLParams){
        if(UrlParameters.res === "success"){
            const safeUrl = sanitizeRedirectUrl(UrlParameters.userurl);
            window.open(safeUrl,'_blank')
            window.location.href = safeUrl
        }else{
        UrlParameters.hostname = `${window.location.protocol}//${window.location.hostname}`;
        if(SessionData.firstPath === "fatti"){
          delete UrlParameters.apmac
          UrlParameters.apMac = fourthPath
          UrlParameters.mikrotik = "True"
          UrlParameters.serverAddress = "192.168.0.1"
          UrlParameters.mac = UrlParameters.usermac
        }

        setSessionData({...SessionData, ...UrlParameters})
        setisLoading(false)
      }
      }
    },[hasURLParams]
    );


    if (ErrorState){
      return (
        <>
          <Toaster position="top-center" />
          <Suspense fallback={<Spinner />}>
            <Error errMsg={ErrorState}/>
          </Suspense>
        </>
      );
    }
    if (isLoading) {
      return (
        <>
          <Toaster position="top-center" />
          <Spinner />
        </>
      );
    } else {
      return (
        <>
          <Toaster position="top-center" />
          <MiddleWare />
        </>
      )
    }
    
}

export default App;
